import { DateQueryDateTypeApiEnum } from './date-query-date-type-api.enum';

export enum DateQueryDateTypeEnum {
    PUBLISHED = 'PUBLISHED',
    HARVESTED = 'HARVESTED',
    SAVED = 'SAVED',
    EDITED = 'EDITED'
}

export const dateQueryDateTypeFromApiMap: Map<DateQueryDateTypeApiEnum, DateQueryDateTypeEnum> = new Map<DateQueryDateTypeApiEnum, DateQueryDateTypeEnum>([
    [ DateQueryDateTypeApiEnum.PUBLISHED, DateQueryDateTypeEnum.PUBLISHED ],
    [ DateQueryDateTypeApiEnum.INDEXED, DateQueryDateTypeEnum.HARVESTED ],
    [ DateQueryDateTypeApiEnum.CREATED, DateQueryDateTypeEnum.SAVED ],
    [ DateQueryDateTypeApiEnum.EDITED, DateQueryDateTypeEnum.EDITED ]
]);

export const dateQueryDateTypeToApiMap: Map<DateQueryDateTypeEnum, DateQueryDateTypeApiEnum> = new Map<DateQueryDateTypeEnum, DateQueryDateTypeApiEnum>([
    [ DateQueryDateTypeEnum.PUBLISHED, DateQueryDateTypeApiEnum.PUBLISHED ],
    [ DateQueryDateTypeEnum.HARVESTED, DateQueryDateTypeApiEnum.INDEXED ],
    [ DateQueryDateTypeEnum.SAVED, DateQueryDateTypeApiEnum.CREATED ],
    [ DateQueryDateTypeEnum.EDITED, DateQueryDateTypeApiEnum.EDITED ]
]);
